import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../features/store";
import { updatePassword } from "../apis/Auth.Api";
import { useNavigate } from "react-router-dom";
import { logOut } from "../features/slices/userDataSlice";
import { Card, RectBtn } from "../components/General";
import { TextField } from "@mui/material";
import { TopNavBar } from "../components/TopNavBar";
import { useSnackbar } from "notistack";

const ResetPassword = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [newPwd, setNewPwd] = useState("");
    const [confirmPwd, setConfirmPwd] = useState("");
    const [pwdNotMatch, setPwdNotMatch] = useState("");
    const userData = useSelector(selectUserData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    async function submitPassword() {
        if (newPwd !== confirmPwd) {
            setPwdNotMatch("Password not match");
            return;
        }
        setPwdNotMatch("");
        const response = await updatePassword({ user_id: userData.userId, password: newPwd });

        if (response.data.indicator) {
            // log out and redirect to log in page
            dispatch(logOut());
            localStorage.removeItem("token");
            console.log("ACCOUNT ACTION | Reset password");
            enqueueSnackbar(response.data.message + " Please log in again.", {
                variant: "success",
            });
            navigate("log-in");
            return;
        } else {
            console.log("Failed to reset pwd", response.data.message);
            enqueueSnackbar(response.data.message, { variant: "error" });
        }
    }
    useEffect(() => {
        enqueueSnackbar("Please reset your password", {
            variant: "info",
        });
    }, []);
    return (
        <div className="page">
            <TopNavBar hideDropDown={true} />
            <div className="reset">
                <Card>
                    <div className="reset-card">
                        <h4>Reset Password</h4>
                        <p className="hint">Please enter new password</p>
                        <TextField
                            placeholder="New password"
                            onChange={(e) => {
                                setNewPwd(e.target.value);
                            }}
                            sx={{ minWidth: "18rem" }}
                            type="password"
                        />
                        <TextField
                            placeholder="Confirm password"
                            onChange={(e) => {
                                setConfirmPwd(e.target.value);
                            }}
                            sx={{ minWidth: "18rem" }}
                            error={pwdNotMatch !== ""}
                            helperText={pwdNotMatch}
                            type="password"
                            onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                    setLoading(true);
                                    await submitPassword();
                                    setLoading(false);
                                }
                            }}
                        />
                        <div className="reset-btn-wrapper">
                            <RectBtn onClick={submitPassword} disable={loading}>
                                <p>Submit</p>
                            </RectBtn>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default ResetPassword;
